import React from "react";
import { Alert, Button, Form } from "react-bootstrap";
import { _t } from "../../app/i18n/i18n";
import { NomuraLogo } from "./NomuraLogo";
import { Link } from "react-router-dom";
import { ErrorMsg } from "./ChangePassword";
import { doMagicLink } from "./api/doMagicLink";

export const MagicLink = ({ location }) => {
  return (
    <section className="w-100 screen-height text-white bg-dark p-5">
      <Form className="maxw-600" onSubmit={(e) => handleMagicLink(e)}>
        <NomuraLogo />
        <p className="text-center font-weight-lighter h5">{_t("Request magic link")}</p>
        <Form.Group className="mt-5">
          <Form.Label>{_t("Email address")}</Form.Label>
          <Form.Control
            type="email"
            name="userName"
            placeholder={_t("Enter email")}
            className="more-border-radius"
            defaultValue={""}
            autoComplete="username"
            required
          />
          <Form.Text>{_t("A login link will be sent to you by email.")}</Form.Text>
        </Form.Group>
        <Button variant="outline-light my-3" className="w-100 more-border-radius" type="submit">
          {_t("Send link")}
        </Button>

        <Button
          variant="outline-secondary mb-3"
          className="w-100 more-border-radius"
          onClick={() => window.history.back()}
        >
          {_t("Back")}
        </Button>
        {location.search.includes("complete") && (
          <Alert variant="info">
            <Alert.Heading>{_t("Please check your email")}</Alert.Heading>
            {_t(
              "Instructions to use GRP magic link will be sent to the email address specified, if this email address is associated with a valid account."
            )}
            <br />
            <b>{""}</b>
          </Alert>
        )}
        {location.search.includes("jpn-gi") && (
          <ErrorMsg
            title={_t("The Global Research Portal is not available for your account.")}
            body={_t(
              "The Global Research Portal is for Professional Investors. If you have any questions regarding this service, please contact Nomura Sales."
            )}
          />
        )}

        {location.search.includes("invalid-token") && (
          <ErrorMsg title={_t("Your magic link request has expired")} body={_t("Please request a new magic link")} />
        )}
        {location.search.includes("fail") && (
          <ErrorMsg
            title={_t("Error")}
            body={_t("A server error has occurred. Please wait a few moments, and try again.")}
          />
        )}
        {location.search.includes("invalid-update") && (
          <ErrorMsg
            title={_t("We were unable to create your magic link")}
            body={_t("Please request a new magic link.")}
          />
        )}
        <Link to="/public/login-support" className="w-100 text-white text-center d-block my-1">
          {_t("Need Support?")}
        </Link>
      </Form>
    </section>
  );
};

function handleMagicLink(e) {
  e.preventDefault();
  const form = e.target;
  //window.userName = form.userName.value;
  doMagicLink(form.userName.value);
}
